import * as angular from 'angular';

import { MobileOS } from 'types/enums';
import { getMobileOS } from 'utilities/devices';

import './styling.scss';
import * as template from './template.html';
import { ModalService } from 'common/source/services/modal';
import { APPLE_APP_STORE_URL, GOOGLE_PLAY_STORE_URL } from 'components/sidebar/app-download-card';

const module = angular.module('mobile-app-download-login-modal', []);

interface LoginModalController extends angular.IStrictController {
    appleAppStoreUrl: string;
    googlePlayStoreUrl: string;
    showAppleAppStoreLink: boolean;
    showGoolePlayStoreLink: boolean;
    isIOS: boolean;
    isAndroid: boolean;
    close: () => void;
}

module.component('mobileAppDownloadLoginModal', {
    template: template,
    controller: function(
        this: LoginModalController,
        modalService: ModalService
    ) {
        this.$onInit = () => {
            const deviceOS = getMobileOS();
            this.appleAppStoreUrl = APPLE_APP_STORE_URL;
            this.googlePlayStoreUrl = GOOGLE_PLAY_STORE_URL;
            this.showAppleAppStoreLink = deviceOS !== MobileOS.Android;
            this.showGoolePlayStoreLink = deviceOS !== MobileOS.iOS;
        };

        this.close = () => {
            modalService.closeAllDialogs();
        };
    }
});

export { module };
